<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-21 11:10:05
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\cloudTeaching\resourcePreview\index.vue
-->
<template>
  <div class="app-container">
    <el-table
      :data="folderList"
      v-loading="loading"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      border
    >
      <el-table-column
        label="文件名"
        prop="fileName"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.isSet">
              <i class="el-icon-folder-opened" style="color: #ffb848"></i>
              <el-input
                ref="inputRef"
                v-model="scope.row.fileName"
                size="small"
                style="margin: 0 10px; width: 50%"
              ></el-input>
              <el-button
                size="mini"
                class="el-icon-check"
                style="color: #129800"
                @click.stop="handleCreateType(scope.row)"
              ></el-button>
              <el-button
                size="mini"
                class="el-icon-close"
                style="color: #ee1200"
                @click.stop="handleCancel(scope.row)"
              ></el-button>
            </div>
            <div v-else>
              <i class="el-icon-folder-opened" style="color: #ffb848"></i>
              <el-link
                style="color: #2a6496"
                type="text"
                @click="handleOpenFolder(scope.row)"
                >{{ scope.row.fileName }}</el-link
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="描述"
        prop="desc"
        align="center"
      ></el-table-column>
      <el-table-column
        label="创建日期"
        prop="createTime"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "resourcePreview",

  components: {},

  mixins: [],

  props: {},

  data() {
    return {
      loading: false,
      // 文件夹列表
      folderList: [
        {
          fileName: "儿科",
          desc: "",
          createTime: "2015-12-01 20:00:00",
        },
        {
          fileName: "基础超声诊断",
          desc: "",
          createTime: "2015-12-01 20:00:00",
        },
        { fileName: "肿瘤科", desc: "", createTime: "2015-12-01 20:00:00" },
        { fileName: "综合科", desc: "", createTime: "2015-12-01 20:00:00" },
        { fileName: "心肺科", desc: "", createTime: "2015-12-01 20:00:00" },
        { fileName: "妇产", desc: "", createTime: "2015-12-01 20:00:00" },
      ],
    };
  },

  provide() {},

  inject: [],

  watch: {},

  computed: {},

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  activated() {},

  deactivated() {},

  beforeDestroy() {},

  destroyed() {},

  methods: {
    /**
     * 打开文件
     */
    handleOpenFolder(row) {
      this.$router.push({
        name: "previewFiles",
      });
    },
  },
};
</script> 


<style scoped>
</style>
